#import './AttachmentFields.graphql'

fragment SuggestionAttachments on Suggestion {
  attachments {
    ...AttachmentFields
  }
}
